import store from '../store';
import Constants from '../config/constants';
import {serviceGetLeadsMaster} from "../services/LeadsMaster.service";
import EventEmitter from "../libs/Events.utils";


export const FETCH_INIT = 'FETCH_INIT_LEADS_MASTER';
export const FETCHED = 'FETCHED_LEADS_MASTER';
export const FETCHED_FAIL = 'FETCHED_FAIL_LEADS_MASTER';
export const FETCHED_FILTER = 'FETCHED_FILTER_LEADS_MASTER';
export const FETCH_NEXT = 'FETCH_NEXT_LEADS_MASTER';
export const FILTER = 'FILTER_LEADS_MASTER';
export const RESET_FILTER = 'RESET_FILTER_LEADS_MASTER';
export const SET_SORTING = 'SET_SORTING_LEADS_MASTER';
export const SET_FILTER = 'SET_FILTER_LEADS_MASTER';
export const SET_PAGE = 'SET_PAGE_LEADS_MASTER';
export const CHANGE_PAGE = 'CHANGE_PAGE_LEADS_MASTER';
export const CHANGE_STATUS= 'CHANGE_STATE_LEADS_MASTER';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_LEADS_MASTER';
export const CREATE_DATA = 'CREATE_LEADS_MASTER';
export const UPDATE_DATA = 'UPDATE_LEADS_MASTER';
export const DELETE_ITEM = 'DELETE_LEADS_MASTER';

export function actionFetchLeadsMaster(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetLeadsMaster({ index, row: sorting.row, order: sorting.order, ...filter });
    
console.log("LeadsMaster request data", request )
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}




export function actionChangePageLeadsMasterRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterLeadsMasterRequests(value) {
    const request = null;
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusLeadsMasterRequests(id, status) {
    
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterLeadsMasterRequests() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageLeadsMasterRequests(page,  extraPayload = {}) {
    const stateData = store.getState().leads_master;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchLeadsMaster(serverPage + 1, sortingData, {query, query_data: queryData,  ...extraPayload}));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}


